import { RouterStore } from 'mobx-react-router'
import { ROUTING_STORE, ViewersStore, VIEWERS_STORE } from 'store'
import { ViewersTableStore, VIEWERS_TABLE_STORE } from 'store/ViewersTableStore'
import { StyleProps } from 'utilities'

export interface ViewersTableProps extends StyleProps {
  [VIEWERS_STORE]?: ViewersStore
  [VIEWERS_TABLE_STORE]?: ViewersTableStore
  [ROUTING_STORE]?: RouterStore
}

// export const viewersTableWidths = {
//   name: 25,
//   dynamicCol: 15,
//   email: 16,
//   gender: 9,
//   age: 13,
//   address: 22
// }
export const viewersTableWidths = {
  name: 400,
  dynamicCol: 300,
  email: 300,
  gender: 200,
  age: 200,
  address: 402
}
